import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
import useSWRV from "swrv";
import { getData } from "@/services/axios";

import { inject, computed, ref } from 'vue';
import { isAuthenticatedKey, allSchoolListKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default {
  __name: 'ForumSelectDetailSchools',
  props: {
    selectSchoolIdList: {
      /** @type {PropType<number[]>} */
      type: Array,
      required: true
    },
    selectGradeIdList: {
      /** @type {PropType<number[]>} */
      type: Array,
      required: true
    }
  },
  emits: ["handleClickNext", "toggleIsShowModal"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // @ts-check

    var isAuthenticated = inject(isAuthenticatedKey);
    var allSchoolList = inject(allSchoolListKey);
    var _useSWRV = useSWRV(function () {
        return isAuthenticated.value && "school-grade";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("school", {
                with: "grade"
              });
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        revalidateOnFocus: false,
        dedupingInterval: Infinity
      }),
      schoolWithGrade = _useSWRV.data;
    var selectSchoolList = computed(function () {
      var _schoolWithGrade$valu;
      var temp = (_schoolWithGrade$valu = schoolWithGrade.value) !== null && _schoolWithGrade$valu !== void 0 ? _schoolWithGrade$valu : [];
      temp = temp.filter(function (v) {
        return props.selectSchoolIdList.includes(v.id);
      });
      return temp;
    });
    var searchWord = ref("");
    var isShowChecked = ref(false);
    var tempSelectIdList = ref(structuredClone(props.selectGradeIdList));
    var childRef = ref();
    var isAllSelect = computed(function () {
      var _childRef$value;
      return (_childRef$value = childRef.value) === null || _childRef$value === void 0 ? void 0 : _childRef$value.every(function (child) {
        return child.isAllGradeSelect();
      });
    });
    var handleAllSelect = function handleAllSelect() {
      if (isAllSelect.value) {
        tempSelectIdList.value = [];
      } else {
        tempSelectIdList.value = childRef.value.flatMap(function (child) {
          return child.getShowGradeIdList();
        });
      }
    };
    var handleClickNext = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var ids;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 学年を選択された学校のみを選択済みにする
              ids = schoolWithGrade.value.filter(function (v) {
                return props.selectSchoolIdList.includes(v.id) && v.grade.some(function (v2) {
                  return tempSelectIdList.value.includes(v2.id);
                });
              }).map(function (v) {
                return v.id;
              });
              emit("handleClickNext", ids, tempSelectIdList.value);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleClickNext() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      isAuthenticated: isAuthenticated,
      allSchoolList: allSchoolList,
      schoolWithGrade: schoolWithGrade,
      selectSchoolList: selectSchoolList,
      searchWord: searchWord,
      isShowChecked: isShowChecked,
      tempSelectIdList: tempSelectIdList,
      childRef: childRef,
      isAllSelect: isAllSelect,
      handleAllSelect: handleAllSelect,
      handleClickNext: handleClickNext
    };
  }
};